import { render } from "./default-banner.html?vue&type=template&id=aa14d17e&ts=true"
import script from "./default-banner.vue?vue&type=script&lang=ts"
export * from "./default-banner.vue?vue&type=script&lang=ts"

import "./default-banner.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__